import React from "react";
import steamIcon from "assets/icons/socials/steam.svg";
import { PUBLIC_CONFIG_KEYS } from "config/publicConfig";
import { useAuth } from "features/account/context/AuthContext";
import { useRuntimeConfig } from "app/providers/RuntimeConfigContext";
import { useTranslation } from "shared/hooks/useTranslation";
import LightButton from "shared/ui/LightButton";

function LoginButton() {
  const { getAuthUrlWithNext } = useAuth();
  const { getRequiredValue } = useRuntimeConfig();
  const { t } = useTranslation();

  const handleLogin = () => {
    const apiUrl = getRequiredValue(PUBLIC_CONFIG_KEYS.apiUrl);
    const currentPath = window.location.pathname;
    const authUrl = getAuthUrlWithNext(
      `${apiUrl}/api/auth/steam/`,
      currentPath,
    );
    window.location.href = authUrl;
  };

  return (
    <LightButton onClick={handleLogin} iconSrc={steamIcon}>
      {t("common.loginWithSteam")}
    </LightButton>
  );
}

export default LoginButton;
